import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import ContainerList from '../../components/ContainerList'
import JsonViewer from '../../components/JsonViewer'
import { JObject } from '../../types/Constants'

interface DataPanelProps {
  containers: Record<string, JObject[]>
}

const DataPanel = ({ containers }: DataPanelProps) => {
  const { t } = useTranslation()
  const [selectedKey, setSelectedKey] = useState<string | null>(null)

  const containerCounts = Object.fromEntries(Object.entries(containers).map(([key, docs]) => [key, docs.length]))

  const selectedDocuments = selectedKey ? containers[selectedKey] ?? [] : []

  return (
    <Box sx={{ display: 'flex', height: 'calc(100vh - 250px)', gap: 2 }}>
      <Box sx={{ width: 300, borderRight: 1, borderColor: 'divider', pr: 1 }}>
        <Typography variant="subtitle2" sx={{ px: 2, py: 1 }}>
          {t('investigation.data.containers')}
        </Typography>
        <ContainerList containers={containerCounts} selectedKey={selectedKey} onSelect={setSelectedKey} />
      </Box>
      <Box sx={{ flex: 1 }}>
        {selectedDocuments.length > 0 ? (
          <JsonViewer documents={selectedDocuments} />
        ) : (
          <Typography color="text.secondary" sx={{ p: 2 }}>
            {t('investigation.data.noDocuments')}
          </Typography>
        )}
      </Box>
    </Box>
  )
}

export default DataPanel
